import React from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import { SmartToy as BotIcon, RestartAlt as RestoreIcon } from '@mui/icons-material';
import { getCurrentUser, HEADER_AUTH_USER_KEY } from '../../services/api';

const clearImpersonation = () => {
  sessionStorage.removeItem(HEADER_AUTH_USER_KEY);
  sessionStorage.removeItem('botLoginActive');
  sessionStorage.removeItem('botAuthSecret');
  sessionStorage.removeItem('testLoginActive');
  sessionStorage.removeItem('qaAuthSecret');
  window.location.reload();
};

const BotImpersonationBanner: React.FC = () => {
  const isBotLogin = sessionStorage.getItem('botLoginActive') === 'true';
  if (!isBotLogin) return null;

  let currentUser: any = {};
  try {
    currentUser = getCurrentUser() || {};
  } catch {
    currentUser = {};
  }
  if (!currentUser.is_bot && !currentUser.bot_persona) return null;

  const displayName = currentUser.display_name || currentUser.username || 'bot';
  const persona = currentUser.bot_persona || currentUser.persona || currentUser.username || 'synthetic user';

  return (
    <Alert
      severity="info"
      icon={<BotIcon fontSize="small" />}
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.appBar + 2,
        borderRadius: 0,
        py: 0.5,
        minHeight: 40,
        alignItems: 'center',
        '& .MuiAlert-message': { width: '100%', py: 0 },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          Logged in as bot <strong>{displayName}</strong> ({persona})
        </Typography>
        <Button
          size="small"
          color="inherit"
          startIcon={<RestoreIcon />}
          onClick={clearImpersonation}
          sx={{ flexShrink: 0 }}
        >
          Restore my account
        </Button>
      </Box>
    </Alert>
  );
};

export default BotImpersonationBanner;
